import api from 'services/api';

export type IntegrationKeyProps = {
  uuid?: string;
  clientId?: string;
  clientSecret?: string;
  keyType?: string;
  preferenceUuid?: string;
  latchKeyType?: string;
  organizationUuid?: string;
};

const findAllIntegrationKeys = async () => {
  const response = await api.get<IntegrationKeyProps[]>('/apiv1/keys/');
  return response?.data;
};

const findIntegrationKeyById = async (uuid: string | undefined) => {
  const response = await api.get<IntegrationKeyProps>(`/apiv1/key/${uuid}/`);
  return response?.data;
};

const createIntegrationKey = async (newIntegrationKey: IntegrationKeyProps) => {
  const response = await api.post<IntegrationKeyProps>('/apiv1/key/', newIntegrationKey);
  return response?.data;
};

const updateIntegrationKey = async (
  uuid: string | undefined,
  updatedIntegrationKey: IntegrationKeyProps
) => {
  const response = await api.put<IntegrationKeyProps>(`/apiv1/key/${uuid}/`, updatedIntegrationKey);
  return response?.data;
};

const deleteIntegrationKeyById = async (uuid: string | undefined) => {
  const response = await api.delete<IntegrationKeyProps>(`/apiv1/key/${uuid}/`);
  return response?.data;
};

const IntegrationKeyService = {
  findAllIntegrationKeys,
  findIntegrationKeyById,
  createIntegrationKey,
  updateIntegrationKey,
  deleteIntegrationKeyById
};

export default IntegrationKeyService;
